module.exports = __webpack_public_path__ + "static/tools-resources-photo-01@2x-66c1fed8440a30ec62633940e4a924db.jpg";